/**
 * Utilidades para validación de RUT chileno
 */

/**
 * Limpia el RUT removiendo puntos y guiones
 */
export const cleanRut = (rut) => {
  return rut.replace(/\./g, '').replace(/-/g, '').trim();
};

/**
 * Formatea el RUT con puntos y guión
 * Ejemplo: 12345678-9 -> 12.345.678-9
 */
export const formatRut = (rut) => {
  const cleaned = cleanRut(rut);
  if (cleaned.length < 2) return cleaned;
  
  const dv = cleaned.slice(-1);
  let number = cleaned.slice(0, -1);
  
  // Agregar puntos cada 3 dígitos desde la derecha
  number = number.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  
  return `${number}-${dv}`;
};

/**
 * Valida el RUT chileno usando el algoritmo módulo 11
 */
export const validateRut = (rut) => {
  if (!rut || rut.trim() === '') return true; // Permitir vacío (validación de required se hace aparte)
  
  const cleaned = cleanRut(rut);
  
  // Debe tener al menos 2 caracteres (número + dígito verificador)
  if (cleaned.length < 2) return false;
  
  // Separar número y dígito verificador
  const dv = cleaned.slice(-1).toUpperCase();
  const number = cleaned.slice(0, -1);
  
  // El número debe ser solo dígitos
  if (!/^\d+$/.test(number)) return false;
  
  // Calcular dígito verificador esperado
  let sum = 0;
  let multiplier = 2;
  
  // Recorrer el número de derecha a izquierda
  for (let i = number.length - 1; i >= 0; i--) {
    sum += parseInt(number[i]) * multiplier;
    multiplier = multiplier === 7 ? 2 : multiplier + 1;
  }
  
  const expectedDv = 11 - (sum % 11);
  let calculatedDv;
  
  if (expectedDv === 11) {
    calculatedDv = '0';
  } else if (expectedDv === 10) {
    calculatedDv = 'K';
  } else {
    calculatedDv = expectedDv.toString();
  }
  
  return dv === calculatedDv;
};

/**
 * Obtiene mensaje de error para RUT inválido
 */
export const getRutErrorMessage = (rut) => {
  if (!rut || rut.trim() === '') return '';
  
  const cleaned = cleanRut(rut);
  
  if (cleaned.length < 2) {
    return 'RUT incompleto';
  }
  
  if (!validateRut(rut)) {
    return 'RUT inválido';
  }
  
  return '';
};
